export const feedPage = {
    'feed.page.feed.tab.posts': 'Посты',
    'feed.page.feed.tab.toys': 'Игрушки',
    'feed.page.toys.placeholder': 'Введите название игрушки',
    'feed.page.posts.placeholder': 'Введите название поста',
    'feed.page.feed.tab.digital': 'Цифровые',
    'feed.page.artists.placeholder': 'Введите название артиста',
    'feed.page.feed.tab.physical': 'Физические',
}
